import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { Fonts, Spacings, mediaQuery } from '@styles/index';
import Radio from 'aquilla/core/atoms/Radio/Radio';
import RadioGroup from 'aquilla/core/atoms/Radio/RadioGroup';

const Container = styled.div``;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  gap: ${Spacings.SPACING_5B};
  color: var(--color-text-primary);
  font-size: ${Fonts.H6};
  flex-wrap: wrap;
  ${mediaQuery.uptoMobile} {
    gap: 28px;
  }
`;

const RadioButtonContainer = ({
  selectionState,
  setSelectionState,
  filterOptions,
  filterNumberSelected,
  sessionType,
  selectedSubject,
  handleSessionTypeChange,
  handleSubjectChange
}) => {
  const isMobile = useIsMobile();
  const onClick = (value) => () => {
    if (isMobile) {
      setSelectionState({ value, type: filterNumberSelected });
    } else if (filterNumberSelected === 0) {
      handleSessionTypeChange(value);
    } else {
      handleSubjectChange(value);
    }
  };
  const getValue = () => {
    if (isMobile) {
      return selectionState.value;
    }
    if (filterNumberSelected === 0) {
      return sessionType;
    }
    return selectedSubject;
  };

  return (
    <>
      <Container>
        <StyledRadioGroup
          name="Recorded Batch"
          value={getValue()}
          className="radio-option"
        >
          {filterOptions[filterNumberSelected].options.map((option) => (
            <div
              key={option.value}
              role="button"
              tabIndex={option.value}
              onClick={onClick(option.value)}
              onKeyDown={() => {}}
            >
              <Radio value={option.value}>{option.label}</Radio>
            </div>
          ))}
        </StyledRadioGroup>
      </Container>
    </>
  );
};

export default RadioButtonContainer;
